import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  backgroundColor?: string
  width?: string
  height?: string
  rotate?: string
}

const CloseIcon: React.FunctionComponent<Props> = (props) => {
  const {
    width,
    height,
    color = '#000000',
    backgroundColor = 'transparent',
  } = props
  return (
    <svg
      viewBox="0 0 10 10"
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-1114 -626)" fill="none">
        <g transform="translate(428 322)" />
        <circle cx="1119" cy="631" r="11" fill={backgroundColor} />
        <path
          fill={color}
          d="m1120.357 630.893 2.589 2.589-1.168 1.167-2.589-2.589-3.068 3.069-1.186-1.186 3.068-3.069-2.589-2.589 1.168-1.167 2.589 2.589 2.835-2.835 1.186 1.186z"
        />
      </g>
    </svg>
  )
}

export default CloseIcon
